'use strict';

const React = require('react'),
    { t } = require('services/i18nextWrapper'),
    SessionStore = require('stores/SessionStore'),
    Notification = require('components/Notification/Notification'),
    AdminScaffolding = require('components/Commons/AdminScaffolding/AdminScaffolding'),
    AdminScaffoldingTable = require('components/Commons/AdminScaffolding/AdminScaffoldingTable/AdminScaffoldingTable'),
    AdminScaffoldingContextHolder = require('components/Commons/AdminScaffolding/AdminScaffoldingContextHolder'),
    FormGroupTextfield = require('components/Commons/BasicForm/FormGroupTextfield/FormGroupTextfield'),
    FormGroupButton = require('components/Commons/BasicForm/FormGroupButton/FormGroupButton'),
    Loading = require('components/Commons/Loading/Loading'),
    ContentUtils = require('utils/ContentUtils'),
    NumberUtils = require('utils/NumberUtils'),
    InventoryStore = require('stores/InventoryStore'),
    NavigationUtils = require('utils/NavigationUtils'),
    AppConstants = require('constants/AppConstants'),
    PurchaseOrderUtils = require('utils/PurchaseOrderUtils'),
    DateUtils = require('utils/DateUtils'),
    FormGroupTextFieldSuggested = require('components/Commons/BasicForm/FormGroupTextFieldSuggested/FormGroupTextFieldSuggested'),
    Authentication = require('services/Security').Authentication,
    ga = require('react-ga'),
    { map, filter, some } = require('lodash/collection'),
    { concat } = require('lodash/array'),
    get = require('lodash/object').get,
    set = require('lodash/object').set,
    { Navigation } = require('react-router'),
    CustomDialog = require('components/Commons/Dialog/CustomDialogHolder');

const VendorPurchaseItemAdmin = React.createClass({displayName: "VendorPurchaseItemAdmin",

    mixins: [Authentication, AdminScaffoldingContextHolder, Navigation],

    getInitialState() {
        return {
            purchaseId: NavigationUtils.getPathParam('purchase-item'),
            vendorId: NavigationUtils.getPathParam('vendors'),
            companyName: NavigationUtils.getQueryParam('companyName'),
            isClosedOrder:
                NavigationUtils.getQueryParam('isClosed') !== 'false',
            comment: NavigationUtils.getQueryParam('comment'),
            selectedItem: null,
            isEditMode: false
        };
    },

    componentDidMount() {
        this.fetchPurchases();
        ga.pageview('/vendor-purchase-item-admin');
    },

    _backToVendor() {
        this.transitionTo('/purchase-item/page/:page', { page: 0 });
    },

    fetchPurchases(callBack) {
        const { purchaseId, vendorId } = this.state;
        const self = this;
        InventoryStore.fetchVendorItems(vendorId, vendorItems => {
            InventoryStore.fetchNonInventoryItems((items) => {
                InventoryStore.fetchVendorPurchasesItem(purchaseId, purchases => {
                    self.setState(
                        {
                            purchases: ContentUtils.filterEnable(self._hydratePurchasesWithExtraInfo(
                                purchases
                            )),
                            vendorItems: concat(
                                ContentUtils.filterEnable(vendorItems),
                                adaptNonInventoryItemToVendorItem(filterExistingNonInventoryItems(items, vendorItems))
                            )
                        },
                        () => {
                            if (callBack) {
                                callBack();
                            }
                        }
                    );
                });
            });
        });
    },

    _hydratePurchasesWithExtraInfo(purchases) {
        return map(purchases, purchase => {
            if (purchase.customArrivalDays) {

                const unit = getUnitFromVendorItem(get(purchase, 'vendorItem'));
                purchase.amountWithUnit = `${NumberUtils.formatDecimal(
                    purchase.amountRequested,get(SessionStore.getCurrentCurrencyDigits(), 'value')
                    )} ${unit}`;

                purchase.amountReceivedWithUnit = `${NumberUtils.formatDecimal(
                    purchase.totalAmountReceived,get(SessionStore.getCurrentCurrencyDigits(), 'value')
                    )} ${unit}`;

                const costVendorPurchaseItem = PurchaseOrderUtils.getPriceOfPurchaseItem(purchase);
                purchase.priceUnitWithCurrency = `${NumberUtils.getCurrentCurrency().symbol} ${NumberUtils.formatDecimal(costVendorPurchaseItem,get(SessionStore.getCurrentCurrencyDigits(), 'value'))}`;
                purchase.totalPriceUnitWithCurrency = `${NumberUtils.getCurrentCurrency().symbol} ${NumberUtils.formatDecimal(
                    NumberUtils.multiply(get(purchase, 'totalAmountReceived') || get(purchase, 'amountRequested'), costVendorPurchaseItem),get(SessionStore.getCurrentCurrencyDigits(), 'value')
                    )}`;

                purchase.dateReceivedDate = DateUtils.toCurrentTimeZone(
                    PurchaseOrderUtils.getLastReceivedDateFromPurchaseOrderItem(purchase),
                    SessionStore.getCurrentTimeZone()
                );

                return set(
                    purchase,
                    'vendorItem.arrivalDays',
                    get(purchase, 'customArrivalDays')
                );
            }
            return purchase;
        });
    },

    _onDeletePurchase(purchase, onSuccess, onFailure) {
        const selectedPurchaseItem = get(this.state, 'selectedItem');
        if (!PurchaseOrderUtils.isAbleToChangeVendorPurchaseItem(selectedPurchaseItem)) {
            Notification.show(t('vendor_purchase_item_sent_cannot_deleted'));
            return;
        }
        CustomDialog.showWarningConfirmation(
            t('warning'),
            t('vendor_purchase_item_confirm_delete'),
            () => {
                InventoryStore.deletePurchaseItem(purchase, onSuccess, onFailure);
            }
        );
    },

    _onChangePurchase(purchase, onSuccess) {
        purchase.amountRequested = NumberUtils.standardiseDecimalFormatNumber(purchase.amountRequested);
        InventoryStore.changeVendorPurchaseItem(
            purchase,
            onSuccess,
            this._onFailurePurchaseItem
        );
        this.setState({
            preSelectedItem: null
        });
    },

    _onAddPurchase(purchase, onSuccess, onFailure) {
        purchase.vendorId = NavigationUtils.getPathParam('vendors');
        purchase.purchaseId = NavigationUtils.getPathParam('purchase-item');
        purchase.amountRequested = NumberUtils.standardiseDecimalFormatNumber(purchase.amountRequested);
        InventoryStore.addVendorPurchaseItem(purchase, onSuccess, onFailure);
        this.setState({
            preSelectedItem: null
        });
    },

    _onRowSelection(selectedItem,
        itemIndex,
        lastRowScrollPosition,
        headerActiveFilters) {
        this.setState(
            {
                selectedItem,
                isEditMode: !!selectedItem,
                headerActiveFilters
            },
            () => {
                // stay the position of the scroll after row select when
                // the offset Y es outside of initial viewport page.
                this.getDOMNode().querySelector(
                    '.mui-body-table'
                ).scrollTop = lastRowScrollPosition;
            }
        );
    },

    _onCancel() {
        this.setState({
            selectedItem: null,
            isEditMode: false
        });
    },

    _onFailurePurchaseItem(messageInfo) {
        if (messageInfo) {
            const haveNotEmail = messageInfo.includes('0008');
            if (haveNotEmail) {
                CustomDialog.showWarningConfirmation(
                    t('warning'),
                    t('vendor_purchase_item_no_email_associated_add_email'),
                    () => {
                        this.transitionTo(
                            '/vendors/:vendorId/contacts',
                            {
                                vendorId: NavigationUtils.getPathParam('vendors')
                            },
                            {
                                companyName: NavigationUtils.getQueryParam('companyName')
                            }
                        );
                    }
                );

            } else {
                const messageError = ContentUtils.formatMessageError(messageInfo);
                Notification.show(messageError);
            }
        }
    },

    _onEnterPress() {
        if (this.onEnterKeyDown) {
            this.onEnterKeyDown();
        }
    },

    _addEnterKeyDown(onEnterKeyDown) {
        this.onEnterKeyDown = onEnterKeyDown;
    },

    _getBreadcrumbLinks() {
        return [
            { link: '/purchase-item/page/0', param: { page: 0 }, displayName: t('vendor_purchase_item_label') },
            { displayName: NavigationUtils.getQueryParam('code') }
        ];
    },

    _backToPurchaseItem() {
        this.transitionTo('/purchase-item/page/:page', { page: 0 });
    },

    _amountValidation(inputValue) {
        let result = NumberUtils.isNumber(NumberUtils.standardiseDecimalFormatNumber(inputValue))
            ? ''
            : t('vendor_purchase_item_amount_must_be_number');
        const isNumber = result === '';

        if (isNumber) {
            const minimumOrder =
                get(this.state, 'selectedItem.vendorItem.minimumOrder') ||
                get(this.state, 'preSelectedItem.minimumOrder');
            const isAmountEnough =
                NumberUtils.isGreater(inputValue, minimumOrder) ||
                NumberUtils.isEqual(inputValue, minimumOrder);
            return isAmountEnough
                ? ''
                : `${t('vendor_purchase_item_amount_must_be_greater')} ${minimumOrder}`;
        }

        return result;
    },

    _onBlurSelectedItem(preSelectedVendorItem) {
        if (preSelectedVendorItem) {
            this.setState(prevState => {
                if (prevState.selectedItem) {
                    return {
                        preSelectedItem: Object.assign(
                            prevState.selectedItem,
                            preSelectedVendorItem
                        )
                    };
                } else {
                    return {
                        preSelectedItem: preSelectedVendorItem
                    };
                }
            });
        }
    },

    _sendToProvider() {
        CustomDialog.showWarningConfirmation(
            t('warning'),
            t('vendor_purchase_confirm_supplier_notification'),
            () => {
                InventoryStore.sendVendorPurchaseOrder(
                    this.state.purchaseId,
                    this._onSuccessPurchaseItem,
                    this._onFailurePurchaseItem
                );
            }
        );
    },

    _saveComment() {
        InventoryStore.saveCommentOnlyVendorPurchase(this.state.purchaseId, this.state.comment !== "" ? this.state.comment : "null");
        Notification.show(t('order').charAt(0).toUpperCase() + t('order').slice(1) + " " + this.state.purchaseId + " " +  t('updated'), 'success')
    },

    _onSuccessPurchaseItem() {
        this.fetchPurchases(() => {
            Notification.show(
                t('vendor_purchase_confirm_order_was_sent'),
                'success'
            );
        });
    },

    _showIndicator(purchase) {
        const bgColor = get(purchase, 'state') === 'PENDING' ? 'red' : 'green';
        return (
            React.createElement("div", null, 
                React.createElement("span", {
                    className: "text-center", 
                    style: {
                        height: '20px',
                        borderRadius: '22px',
                        boxShadow: '1px 2px 4px 0px gray',
                        backgroundColor: bgColor,
                        border: 'solid 0px black',
                        padding: '10px 17px',
                        left: '0',
                        position: 'relative',
                        opacity: '.6'
                    }}
                ), 
                React.createElement("span", {style: { paddingLeft: '10px'}}, get(purchase, 'needConfirm'))
            )
        );
    },

    _commentValidation(inputValue) {
        this.state.comment = inputValue;
        if (ContentUtils.isEmptyText(this.state.comment)) {
            return '';
        }
        if (get(this.state.comment, 'length') >= 200) {
            return t('vendor_purchase_max_amount_characters');
        }

        return '';
    },

    _printPO() {
        var code = NavigationUtils.getQueryParam('code');
        InventoryStore.downloadReportXLS("", 'vendors/purchases/'+this.state.purchaseId);
    },

    render() {
        const { purchases } = this.state;
        if (!purchases) {
            return React.createElement(Loading, null);
        } else {
            const messages = {
                changeSuccessMessage: t('vendor_purchase_item_change_success_message'),
                changeFailureMessage: t('vendor_purchase_item_change_failure_message'),
                deleteSuccessMessage: t('vendor_purchase_item_delete_success_message'),
                addSuccessMessage: t('vendor_purchase_item_add_success_message'),
                addFailureMessage: t('vendor_purchase_item_add_failure_message')
            };
            const orderStateMapping = AppConstants.getPurchaseStateMapping(t);
            const contextHolder = this.getContextHolderInstance();
            const {
                selectedItem,
                purchases,
                isEditMode,
                vendorItems,
                preSelectedItem,
                isClosedOrder,
                companyName,
                comment
            } = this.state;
            const vendorItemPurchases = map(purchases, purchase =>
                get(purchase, 'vendorItem')
            );

            let unit;

            if (selectedItem) {
                unit = getUnitFromVendorItem(get(selectedItem, 'vendorItem'));
            } else {
                unit = getUnitFromVendorItem(preSelectedItem);
            }

            let additionalButtons = [
                {
                    type: 'CHANGE',
                    permission: 'SHOW',
                    el: (
                        React.createElement(FormGroupButton, {
                            label: t('back'), 
                            icon: "subdirectory_arrow_left", 
                            type: "icon", 
                            onClick: this._backToVendor}
                        )
                    )
                },
                {
                    type: 'NEW',
                    permission: 'SHOW',
                    el: (
                        React.createElement(FormGroupButton, {
                            label: t('back'), 
                            icon: "subdirectory_arrow_left", 
                            type: "icon", 
                            onClick: this._backToVendor}
                        )
                    )
                },{
                    type: 'NEW',
                    permission: 'PRINT_REPORT',
                    el: (
                        React.createElement(FormGroupButton, {
                            label: t('purchase_print'), 
                            icon: "file_download", 
                            type: "icon", 
                            onClick: this._printPO}
                        )
                    )
                }
            ];

            // once have next state of MORE_ON_THE_WAY should not return ir
            const currentStateItem = get(selectedItem, 'state', '');
            const shouldBeImmutable =
                isClosedOrder ||
                (isEditMode &&
                    (currentStateItem === 'NO_MORE_ON_THE_WAY' ||
                        currentStateItem === 'REJECT_REMAINDER'));

            const unitWithParenthesis = unit ? '(' + unit + ')' : '(' + t('unit') + ')';
            
            const formFieldsEl = [
                React.createElement(FormGroupTextFieldSuggested, {
                    isDisabled: shouldBeImmutable, 
                    operationsHolder: contextHolder, 
                    items: vendorItems, 
                    readerAttribute: "item.description", 
                    readerAttributeValue: "id", 
                    writerAttribute: "vendorItemId", 
                    itemsDisabled: filterItemsAlreadyInUse(
                        vendorItems,
                        vendorItemPurchases
                    ), 
                    customErrorNonMatch: t('sales_items_error_non_match'), 
                    name: t('item'), 
                    isImmutable: true, 
                    isEditMode: isEditMode, 
                    label: `${t('item')} ${unitWithParenthesis}`, 
                    value: get(selectedItem, 'vendorItem') || preSelectedItem, 
                    onBlur: this._onBlurSelectedItem, 
                    onEnter: this._onEnterPress}
                ),
                React.createElement(FormGroupTextfield, {
                    isDisabled: shouldBeImmutable, 
                    operationsHolder: contextHolder, 
                    readerAttribute: "amountRequested", 
                    additionalValidation: this._amountValidation, 
                    name: t('vendor_item_label_amount'), 
                    value: selectedItem, 
                    label: `${t('vendor_item_label_amount')} ${unitWithParenthesis}`, 
                    isRelaxedText: true, 
                    isDecimalFormat: false, 
                    isEditMode: isEditMode, 
                    onEnter: this._onEnterPress}
                ),

                React.createElement(FormGroupTextfield, {
                    isDisabled: shouldBeImmutable, 
                    operationsHolder: contextHolder, 
                    displayAttribute: "vendorItem.arrivalDays", 
                    readerAttribute: "vendorItem.arrivalDays", 
                    writerAttribute: "customArrivalDays", 
                    name: t('vendor_purchase_item_arrival_days'), 
                    label: t('vendor_purchase_item_arrival_days'), 
                    additionalValidation: inputValue =>
                        NumberUtils.isNumber(inputValue)
                            ? (NumberUtils.isGreater(inputValue, 0) ? '' : t('vendor_purchase_item_arrival_day_greater_zero'))
                            : t('vendor_purchase_item_arrival_days_must_be_number'), 
                    value: selectedItem || { vendorItem: preSelectedItem }, 
                    isEditMode: isEditMode, 
                    onEnter: this._onEnterPress}
                ),
                React.createElement(FormGroupTextfield, {
                    operationsHolder: contextHolder, 
                    readerAttribute: "comment", 
                    name: t('order').charAt(0).toUpperCase() + t('order').slice(1) +" "+t('comment'), 
                    value: this.state, 
                    label: t('order').charAt(0).toUpperCase() + t('order').slice(1) +" "+t('comment'), 
                    additionalValidation: inputValue => this._commentValidation(inputValue), 
                    isRelaxedText: false, 
                    noInternalValidation: true, 
                    isEditMode: isEditMode, 
                    isRequired: false, 
                    onEnter: this._onEnterPress, 
                    id: "comment"}
                )

            ];

            const haveSomePurchaseItem = ContentUtils.isNotEmptyArray(
                purchases
            );
            const haveSomePurchaseItemPending = some(
                purchases,
                purchase => get(purchase, 'state') === 'PENDING'
            );
            const haveSomeNonPurchaseItemPending = some(
                purchases,
                purchase => get(purchase, 'state') !== 'PENDING'
            );

            if (!isClosedOrder && haveSomePurchaseItem && haveSomePurchaseItemPending) {
                additionalButtons.push({
                    type: 'NEW',
                    permission: 'SEND_PENDING_ORDER',
                    el: (
                        React.createElement(FormGroupButton, {
                            label: t('vendor_purchase_label_send_pending'), 
                            icon: "send", 
                            type: "icon", 
                            onClick: this._sendToProvider}
                        )
                    )
                });
            } else if (!isClosedOrder && haveSomePurchaseItem && haveSomeNonPurchaseItemPending) {
                additionalButtons.push({
                    type: 'CHANGE',
                    permission: 'SEND_PENDING_ORDER',
                    el: (
                        React.createElement(FormGroupButton, {
                            label: t('vendor_purchase_item_label_resend_pending'), 
                            icon: "send", 
                            type: "icon", 
                            onClick: this._sendToProvider}
                        )
                    )
                });
                additionalButtons.push({
                    type: 'NEW',
                    permission: 'SEND_PENDING_ORDER',
                    el: (
                        React.createElement(FormGroupButton, {
                            label: t('vendor_purchase_item_label_resend_pending'), 
                            icon: "send", 
                            type: "icon", 
                            onClick: this._sendToProvider}
                        )
                    )
                });
            }

            additionalButtons.push({
                type: 'NEW',
                permission: 'SAVE_COMMENT',
                el: (
                    React.createElement(FormGroupButton, {
                        label: t('button_label_save_comment'), 
                        icon: "save", 
                        type: "icon", 
                        onClick: this._saveComment}
                    )
                )
            });

            return (
                React.createElement(AdminScaffolding, {
                    messages: messages, 
                    moduleName: "ADMIN_PURCHASE", 
                    additionalButtons: additionalButtons, 
                    title: 
                        isClosedOrder
                            ? (isIncompleteOrder(purchases) ? t('vendor_purchase_item_state_closed_incomplete') : t('vendor_purchase_item_state_closed_complete'))
                            : t('vendor_purchase_item_order_from') + companyName, 
                    
                    contextHolder: contextHolder, 
                    value: selectedItem, 
                    fetchItems: this.fetchPurchases, 
                    headerFields: formFieldsEl, 
                    onAdd: 
                        shouldBeImmutable || isClosedOrder
                            ? undefined
                            : this._onAddPurchase, 
                    
                    onChange: 
                        shouldBeImmutable || isClosedOrder
                            ? undefined
                            : this._onChangePurchase, 
                    
                    onCancel: this._onCancel, 
                    onDelete: 
                        shouldBeImmutable || isClosedOrder
                            ? undefined
                            : this._onDeletePurchase, 
                    
                    addEnterKeyDown: this._addEnterKeyDown, 
                    breadcrumb: this._getBreadcrumbLinks(), 
                    isDark: true
                }, 
                    React.createElement(AdminScaffoldingTable, {
                        sortByColumn: "vendorItem.item.description", 
                        onRowSelection: this._onRowSelection, 
                        value: selectedItem, 
                        filteredColumns: [
                            'vendorItem.item.description',
                            'amountWithUnit',
                            'amountReceivedWithUnit',
                            'priceUnitWithCurrency',
                            'totalPriceUnitWithCurrency',
                            'dateReceivedDate',
                            'displayState',
                            'vendorItem.arrivalDays'
                        ], 
                        displayAttributes: [
                            'vendorItem.item.description',
                            'amountWithUnit',
                            'amountReceivedWithUnit',
                            'priceUnitWithCurrency',
                            'totalPriceUnitWithCurrency',
                            'dateReceivedDate',
                            'displayState',
                            'vendorItem.arrivalDays',
                            {
                                getHTML: this._showIndicator
                            }
                        ], 
                        columnNames: [
                            t('vendor_purchase_item_column_item'),
                            t('vendor_purchase_item_column_amt_requested'),
                            t('vendor_purchase_item_column_amt_received'),
                            t('vendor_purchase_item_column_unit_price'),
                            t('vendor_purchase_item_column_total_price'),
                            t('vendor_purchase_item_column_date_received'),
                            t('vendor_purchase_column_name_status'),
                            t('vendor_item_label_arrival_days'),
                            t('vendor_purchase_item_column_email_status')
                        ]
                    }, 
                        purchases.map(purchase => {
                            purchase.displayState = orderStateMapping[purchase.state];
                            return purchase;
                        })
                    )
                )
            );
        }
    }
});

function filterItemsAlreadyInUse(items, vendorItems) {
    const itemIdsAlreadyInUse =
        map(vendorItems, vendorItem => get(vendorItem, 'item.id')) || [];
    const itemsFiltered = filter(items, item =>
        itemIdsAlreadyInUse.includes(get(item, 'item.id'))
    );
    const itemsMarked = map(itemsFiltered, item => {
        item.isDisabled = true;
        return item;
    });

    return itemsMarked;
}

function filterExistingNonInventoryItems(items, vendorItems) {
    const alreadyExistingItemsId = map(vendorItems, vendorItem => get(vendorItem, 'item.id')) || [];
    return filter(items, item => alreadyExistingItemsId.indexOf(get(item, 'id')) === -1);
}

function isIncompleteOrder(purchases) {
    return some(purchases, purchase => NumberUtils.isLess(get(purchase, 'totalAmountReceived'), get(purchase, 'amountRequested')));
}

function getUnitFromVendorItem(vendorItem) {
    return get(vendorItem, 'supplierUnit') || get(vendorItem, 'item.unit');
}

function adaptNonInventoryItemToVendorItem(nonInventoryItems = []) {
    return map(nonInventoryItems, nonInventoryItem => {
        nonInventoryItem.item = {
            id: nonInventoryItem.id,
            description: nonInventoryItem.description
        };
        nonInventoryItem.minimumOrder = 1;
        return nonInventoryItem;
    });
}

module.exports = VendorPurchaseItemAdmin;



/** WEBPACK FOOTER **
 ** ./src/views/VendorPurchaseAdmin/VendorPurchaseItemAdmin.jsx
 **/